// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_ah-3";
export var contentContainer = "_ah-0";
export var editorContainer = "_ah-1";
export var quillInputForm = "_ah-2";
export var zoneDivider = "_ah-4";